import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import ImageUpload from './ImageUpload';
import './ServicesAdmin.css';

const ServicesAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    const data = getContent(contentPath);
    setSectionData(data);
  }, [contentPath, getContent]);

  const handleServiceUpdate = (index, field, value) => {
    updateContent(`${contentPath}.services.${index}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleFeatureUpdate = (serviceIndex, featureIndex, value) => {
    updateContent(`${contentPath}.services.${serviceIndex}.features.${featureIndex}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddFeature = (serviceIndex) => {
    const service = sectionData.services[serviceIndex];
    const features = service.features || [];
    updateContent(`${contentPath}.services.${serviceIndex}.features`, [...features, 'Nouvelle caractéristique']);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteFeature = (serviceIndex, featureIndex) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette caractéristique ?')) {
      const service = sectionData.services[serviceIndex];
      const updatedFeatures = service.features.filter((_, i) => i !== featureIndex);
      updateContent(`${contentPath}.services.${serviceIndex}.features`, updatedFeatures);
      setSectionData(getContent(contentPath));
    }
  };

  if (!sectionData) {
    return (
      <div className="services-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="services-admin">
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-briefcase"></i>
            Services Principaux
          </h2>
          <p>Gérez les 4 services : Séminaires, Formation, Coaching, Consulting</p>
        </div>
      </div>

      <div className="services-list-admin">
        {(sectionData.services || []).map((service, index) => (
          <div key={service.id} className={`service-item-admin service-${service.color}`}>
            <div className="service-header">
              <div className="service-title-area">
                <i className={service.icon}></i>
                <h3>{service.title}</h3>
              </div>
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Titre du Service</label>
                <input
                  type="text"
                  value={service.title || ''}
                  onChange={(e) => handleServiceUpdate(index, 'title', e.target.value)}
                  placeholder="Séminaires"
                />
              </div>

              <div className="form-group">
                <label>Icône FontAwesome (fallback si pas d'image)</label>
                <input
                  type="text"
                  value={service.icon || ''}
                  onChange={(e) => handleServiceUpdate(index, 'icon', e.target.value)}
                  placeholder="fas fa-chalkboard-teacher"
                />
              </div>

              <div className="form-group full-width">
                <label>Image du Service</label>
                <ImageUpload
                  value={service.image}
                  onChange={(url) => handleServiceUpdate(index, 'image', url)}
                  label="Télécharger une image"
                />
                <small style={{color: '#6b7280', fontSize: '12px', display: 'block', marginTop: '8px'}}>
                  Recommandé: 800x600px. L'image sera utilisée à la place de l'icône.
                </small>
              </div>

              <div className="form-group full-width">
                <label>Description</label>
                <textarea
                  value={service.description || ''}
                  onChange={(e) => handleServiceUpdate(index, 'description', e.target.value)}
                  placeholder="Description du service..."
                  rows={3}
                />
              </div>
            </div>

            <div className="features-section">
              <h4>
                <i className="fas fa-check-circle"></i>
                Caractéristiques "Ce que vous obtenez"
              </h4>
              
              <div className="features-list-admin">
                {(service.features || []).map((feature, featureIndex) => (
                  <div key={featureIndex} className="feature-item-admin">
                    <input
                      type="text"
                      value={feature}
                      onChange={(e) => handleFeatureUpdate(index, featureIndex, e.target.value)}
                      placeholder="Caractéristique..."
                    />
                    <button
                      type="button"
                      className="btn-delete-feature"
                      onClick={() => handleDeleteFeature(index, featureIndex)}
                      title="Supprimer"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                ))}
              </div>

              <button
                type="button"
                className="btn-add-feature"
                onClick={() => handleAddFeature(index)}
              >
                <i className="fas fa-plus"></i>
                Ajouter une caractéristique
              </button>
            </div>

            <div className="service-info-box">
              <i className="fas fa-info-circle"></i>
              <div>
                <strong>Boutons automatiques :</strong>
                <ul>
                  <li><strong>Formation :</strong> Lien vers la page Formations</li>
                  <li><strong>Coaching & Consulting :</strong> Lien vers la liste des experts</li>
                  <li><strong>Séminaires :</strong> Bouton WhatsApp</li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesAdmin;
